// extracted by mini-css-extract-plugin
module.exports = {"container":"Title_container__rVqgv","withTotal":"Title_withTotal__vQdW7","titleWrapper":"Title_titleWrapper__zDdAC","resultCount":"Title_resultCount__jT8t_"};